'use client';

import { ArrowLeft, Home } from 'lucide-react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

import { MessageDisplay, MessageDisplayButton } from '@/components/message-display';

const NotFoundPage: React.FC = () => {
  const router = useRouter();

  const handleGoBack = () => {
    router.back();
  };

  return (
    <MessageDisplay
      intent="error"
      title="Page not found"
      description="The page you're looking for doesn't exist or has been moved. Let's get you back on track."
      size="page"
      errorCode={404}
      className="h-screen"
    >
      <MessageDisplayButton onClick={handleGoBack}>
        <ArrowLeft className="size-4" />
        Go back
      </MessageDisplayButton>
      <MessageDisplayButton variant="default" asChild>
        <Link href="/">
          <Home className="size-4" />
          Back to home
        </Link>
      </MessageDisplayButton>
    </MessageDisplay>
  );
};

export default NotFoundPage;
